<template>
  <div class>
    <md-card class="cardPrincipal">
      <md-card-content class="contentCardPrincipal">
        <md-card v-if="visibleChapters.length == 0">
          <md-card-header class="md-title">
            <i>Vazio</i>
          </md-card-header>
          <md-card-header-text class="md-subhead" style="padding-left: 4px;">
            Nenhuma história aqui. Conte a sua!
          </md-card-header-text>
          <md-card-actions>
            <md-button @click="onCreateChapter">Contar história</md-button>
          </md-card-actions>
        </md-card>
        <div v-else>
          <chapter-small
            v-for="chapter in visibleChapters"
            :key="chapter.id"
            :chapter="chapter"
            :profile="profIds[chapter.author]"
          />
          <load-more
            :show="hasMore"
            :page="options.pagination.page"
            :pageSize="options.pagination.pageSize"
            @loadPage="loadPagination"
          />
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import LogRocket from "logrocket";
import loadMore from "@/components/shared/loadMore";
import chapterSmall from "./chapterSmall.vue";
import mapMath from "@/assets/js/mapMath";
import call from '@/api/calls';
import bus from '@/api/bus';

const log = (error, method, data) => {
  LogRocket.captureException(error, {
    extra: {
      method,
      data
    }
  });
}

export default {
  name: 'CardFeed',
  components: {
    chapterSmall,
    loadMore
  },
  props: ["groups", "zoom", "center"],
  data() {
    return {
      chapters: [],
      profiles: [],
      chapIds: {},
      profIds: {},
      hasMore: true,
      options: {
        pagination: {
          page: 0,
          pageSize: 8
        }
      },
      error: null
    }
  },
  computed: {
    visibleChapters() {
      // TODO: verificar isso com o postgis
      let center = this.center, zoom = this.zoom;
      return this.chapters.filter(chap => this.withinRange(chap.position, center, zoom) && this.groups.includes(chap.group));
    }
  },
  mounted() {
    this.$route.params.isProduction ? this.loadData(this.options) : this.loadStaticData();
  },
  watch: {
    groups() {
      this.options.page = 0;
      this.loadData(this.options);
    }
  },
  methods: {
    loadData(options) {
      this.loadChapters(options)
      .then(profiles => profiles.length && this.loadProfiles(profiles))
      .catch(error => {
        log(error, "loadData(options)", null);
        return this.error = error;
      });
    },
    loadChapters(options) {
      return call.chapter.getByGroups(this.groups, options)
      .then(chapters => {
        this.hasMore = chapters.length >= this.options.pagination.pageSize;
        let newProfiles = [];
        for(let chapter of chapters) {
          if (!this.chapIds[chapter.id]) {
            this.chapters.push(chapter);
            this.chapIds[chapter.id] = true;
          }
          if (!this.profIds[chapter.author]) {
            newProfiles.push(chapter.author);
            this.profIds[chapter.author] = {};
          }
        }
        return newProfiles;
      });
    },
    loadProfiles(ids) {
      return call.profile.getChaptersData(ids)
      .then(profiles => {
        for(let profile of profiles) {
          this.profIds = Object.assign({}, this.profIds, { [profile.id]: profile });
        }
      });
    },
    withinRange(pos1, pos2, zoom) {
      return pos1 && mapMath.distanceFromPosition(pos1, pos2) < mapMath.zoomToDistanceS(zoom);
    },
    loadPagination(pagination) {
      this.options.pagination = pagination;
      this.loadData(this.options);
    },
    loadStaticData() {
      this.chapters = [
        {
          id: 1,
          author: 1,
          dateStart: 'Date',
          title: 'Cristo foi oferecido em sacrifício uma unica vez, para tirar os pecados de muitos',
          media: {
            image: ['https://i.pinimg.com/originals/da/57/aa/da57aa7b263435f02854d0c1a23a17db.jpg'],
            video: ['video'],
            audio: ['audio']
          },
          content: 'Ele é a propiciação pelos nossos pecados, e não somente pelos nossos, mas também pelos pecados de todo o mundo. 1 João 2:2',
          position: {}
        },
        {
          id: 2,
          author: 2,
          dateStart: 'Date',
          title: 'Titulo',
          media: {
            video: ['video'],
          },
          content: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio itaque ea nostrum.',
          position: {}
        },
        {
          id: 3,
          author: 2,
          dateStart: 'Date',
          title: 'Titulo',
          media: {
            image: ['https://www.wallpaperscristaos.com.br/wp-content/uploads/2019/04/wallpaper-cristao-ele-vive-tumba-vazia_1366x768.jpg'],
            audio: ['audio']
          },
          content: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio itaque ea nostrum.',
          position: {}
        },
        {
          id: 4,
          author: 2,
          dateStart: 'Date',
          title: 'Titulo',
          media: {
          },
          content: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio itaque ea nostrum.',
          position: {}
        },
      ]
      this.profiles = [
        {
          id: 1,
          profileImg: require('@/assets/avatarDefault.png'),
          fullName: 'Mais Evangélio'
        },
        {
          id: 2,
          profileImg: require('@/assets/avatarDefault.png'),
          name: 'Name'
        }
      ]
    },
    onCreateChapter() {
      bus.emit.createFromSidebar();
    }
  },
};
</script>

<style  scoped>
.card-expansion {
  max-height: 280px;
}

.cardPrincipal {
  width: 400px;
  height: 100%;
  margin: 0;
  display: inline-block;
  vertical-align: top;
  overflow-y: auto;
  box-shadow: none;
  background: linear-gradient(0deg, rgba(228,249,245,0), rgba(228,249,245,0.5), #e4f9f5);
  z-index: 1;
}

.md-card-content.contentCardPrincipal {
  padding-top: 1em;
  padding-bottom: 0;
}

.subCardFeed {
  width: 100%;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
  overflow: hidden;
}

.imageCard {
  height: 14vh !important;
}

::-webkit-scrollbar-track {
  opacity: 0;
}
::-webkit-scrollbar {
  width: 6px;
  background: #c6e7e1;
}
::-webkit-scrollbar-thumb {
  background: #11999e;
}

@media (max-width: 451px) {
  .cardPrincipal {
    width: 100%;
    height: 100%;
    top: 0;
    margin: 0;
    background-color: #fff;
  }

  .contentCardPrincipal {
    margin: 4em 0 0.5em 0;
  }
}

@media (max-width: 375px) {
  .cardPrincipal {
    width: 100%;
    height: auto;
    top: 0;
    margin: 0;
    background-color: #fff;
  }

  .contentCardPrincipal {
    margin: 4.5em 0 0.5em 0;
  }
}

@media (max-width: 320px) {
  .cardPrincipal {
    width: 100%;
    height: auto;
    top: 0;
    background-color: #fff;
  }
}

@media (max-height: 414px) {
  .cardPrincipal {
    height: 85%;
  }
}
</style>
